if (!Number.isNan) {
  Object.defineProperty(Number, 'isNaN', {
    value: function(value) {
      // eslint-disable-next-line no-self-compare
      return value !== value
    },
  })
}



// WEBPACK FOOTER //
// ./src/polyfills/numberIsNan.js